import { apiClient } from './apiClient';

/**
 * 닉네임 자동완성 검색.
 * @param {string} prefix 최소 1자 이상
 * @param {number} size   기본 10, 최대 50
 */
export const searchCustomerNicknames = async (prefix, size = 10) => {
  const params = new URLSearchParams({ prefix, size: String(size) });
  return await apiClient(
    `/admin/notifications/marketing/customers/search?${params.toString()}`,
    { method: 'GET' },
    true
  );
};

/**
 * 마케팅 푸시 발송.
 * @param {{ targetNicknames: string[], title: string, body: string }} payload
 */
export const sendMarketingPush = async (payload) => {
  return await apiClient(
    '/admin/notifications/marketing',
    { method: 'POST', body: JSON.stringify(payload) },
    true
  );
};
